var _path, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoItems(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 564,
    height: 322,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "no-items_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -180,
    width: 564,
    height: 792
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(90 563.2 -180)",
    fill: "url(#no-items_svg__paint0_radial_143_8245)",
    d: "M563.2-180h792v563.2h-792z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#no-items_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    stroke: "#000",
    strokeWidth: 1.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M563.2 26.8H0M563.2 68.05H0M563.2 109.3H0M563.2 150.55H0M563.2 191.8H0"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    stroke: "#000",
    strokeWidth: 1.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M563.2 233.05H0M563.2 274.3H0M563.2 315.55H0"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    stroke: "#000",
    strokeWidth: 1.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M528.55 612v-792M239.8 612v-792M487.3 612v-792M198.55 612v-792M446.05 612v-792M157.3 612v-792M404.8 612v-792M116.05 612v-792M363.55 612v-792M74.8 612v-792M322.3 612v-792M33.55 612v-792M281.05 612v-792"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.05,
    y: 25.7,
    width: 1.65,
    height: 10.45,
    rx: 0.825,
    transform: "rotate(90 39.05 25.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.65,
    y: 31.75,
    width: 1.65,
    height: 10.45,
    rx: 0.825,
    transform: "rotate(-180 34.65 31.75)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.05,
    y: 190.7,
    width: 1.65,
    height: 10.45,
    rx: 0.825,
    transform: "rotate(90 39.05 190.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.65,
    y: 196.75,
    width: 1.65,
    height: 10.45,
    rx: 0.825,
    transform: "rotate(-180 34.65 196.75)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.05,
    y: 25.7,
    width: 1.65,
    height: 10.45,
    rx: 0.825,
    transform: "rotate(90 204.05 25.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.65,
    y: 31.75,
    width: 1.65,
    height: 10.45,
    rx: 0.825,
    transform: "rotate(-180 199.65 31.75)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.05,
    y: 190.7,
    width: 1.65,
    height: 10.45,
    rx: 0.825,
    transform: "rotate(90 204.05 190.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.65,
    y: 196.75,
    width: 1.65,
    height: 10.45,
    rx: 0.825,
    transform: "rotate(-180 199.65 196.75)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.05,
    y: 25.7,
    width: 1.65,
    height: 10.45,
    rx: 0.825,
    transform: "rotate(90 369.05 25.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.65,
    y: 31.75,
    width: 1.65,
    height: 10.45,
    rx: 0.825,
    transform: "rotate(-180 364.65 31.75)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.05,
    y: 190.7,
    width: 1.65,
    height: 10.45,
    rx: 0.825,
    transform: "rotate(90 369.05 190.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.65,
    y: 196.75,
    width: 1.65,
    height: 10.45,
    rx: 0.825,
    transform: "rotate(-180 364.65 196.75)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 534.05,
    y: 25.7,
    width: 1.65,
    height: 10.45,
    rx: 0.825,
    transform: "rotate(90 534.05 25.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 529.65,
    y: 31.75,
    width: 1.65,
    height: 10.45,
    rx: 0.825,
    transform: "rotate(-180 529.65 31.75)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 534.05,
    y: 190.7,
    width: 1.65,
    height: 10.45,
    rx: 0.825,
    transform: "rotate(90 534.05 190.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 529.65,
    y: 196.75,
    width: 1.65,
    height: 10.45,
    rx: 0.825,
    transform: "rotate(-180 529.65 196.75)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#no-items_svg__filter0_ddii_143_8245)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 182,
    width: 70,
    height: 70,
    rx: 14,
    transform: "rotate(180 322 182)",
    fill: "url(#no-items_svg__paint1_linear_143_8245)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.7,
    y: 182.7,
    width: 71.4,
    height: 71.4,
    rx: 14.7,
    transform: "rotate(180 322.7 182.7)",
    stroke: "#E2E8F0",
    strokeWidth: 1.4,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.125 129.5l-9.625 15.75h19.25l-9.625-15.75zm0 6.72l3.378 5.53h-6.773l3.395-5.53zm9.625 12.53a7.864 7.864 0 00-7.875 7.875 7.864 7.864 0 007.875 7.875 7.864 7.864 0 007.875-7.875 7.864 7.864 0 00-7.875-7.875zm0 12.25a4.377 4.377 0 01-4.375-4.375 4.377 4.377 0 014.375-4.375 4.377 4.377 0 014.375 4.375A4.377 4.377 0 01295.75 161zm-25.375 2.625h14v-14h-14v14zm3.5-10.5h7v7h-7v-7z",
    fill: "#94A3B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "no-items_svg__paint0_radial_143_8245",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-137.5002 73.69916 -109.07056 -203.49248 959.2 98.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D4D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9292",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "no-items_svg__paint1_linear_143_8245",
    x1: 328.3,
    y1: 182,
    x2: 407.4,
    y2: 257.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4F4",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "no-items_svg__filter0_ddii_143_8245",
    x: 242.2,
    y: 102.9,
    width: 89.6,
    height: 89.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_143_8245"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_143_8245",
    result: "effect2_dropShadow_143_8245"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_143_8245",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect3_innerShadow_143_8245"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect3_innerShadow_143_8245",
    result: "effect4_innerShadow_143_8245"
  })))));
}
export default SvgNoItems;